// Done-for-you: la configuración del cliente la edita solo el superadmin.
// El client_admin opera oportunidades, contactos, chats, estadísticas y equipo,
// y sigue editando el contenido del sitio (cms). Estas funciones las usan las
// rutas (redirigen) y el menú (oculta).

export const CONFIG_SETTINGS_TABS = ['notifications', 'chatbot', 'schemas'] as const;

const CONFIG_PATHS = new Set([
  '/chatbot',
  '/schemas',
  '/configuracion/correo',
  '/configuracion/agentes',
]);

export function configRouteRedirect(
  role: string | null | undefined,
  pathname: string,
  tab?: string | null,
): { to: '/' | '/crm' | '/team' } | null {
  const path = (pathname.split('?')[0] || '/').replace(/\/+$/, '') || '/';
  // Equipo vive en Personas, no dentro de Configuración / Mi perfil.
  if (path === '/settings' && tab === 'team') return { to: '/team' };
  if (role === 'superadmin') return null;
  // El editor de etapas es configuración. El tablero (operación) está en /crm.
  if (path === '/pipelines' || (path === '/settings' && tab === 'pipelines')) {
    return { to: '/crm' };
  }
  if (path === '/clientes' || path.startsWith('/clientes/')) return { to: '/' };
  if (CONFIG_PATHS.has(path)) return { to: '/' };
  if (path === '/settings' && tab && (CONFIG_SETTINGS_TABS as readonly string[]).includes(tab)) {
    return { to: '/' };
  }
  return null;
}

export function hideConfigFromClientMenu(role: string | null | undefined, to: string): boolean {
  if (role === 'superadmin') return false;
  return (
    to === '/chatbot' ||
    to === '/schemas' ||
    to === '/pipelines' ||
    to === '/configuracion/correo' ||
    to === '/configuracion/agentes'
  );
}
